import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import axios from 'axios';
Vue.prototype.$axios = axios;
import QS from 'qs'
Vue.prototype.qs = QS;
import Viser from 'viser-vue'
Vue.use(Viser)
Vue.use(Antd)
Vue.config.productionTip = false
import router from './router/index.js'	
import http from './https.js'
Vue.prototype.$http = http
Vue.prototype.$host = 'https://yjlp.dayujh.cn'
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
